import React from 'react';
import * as S from './styles';
import { motion } from 'framer-motion';

export const Hero: React.FC = () => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <S.Container className="hero">
      <S.Blob1 />
      <S.Blob2 />

      <S.Content>
        <S.Badge>
          <S.BadgeDot />
          App disponível agora
        </S.Badge>
        <S.Title>
          Planeje sua
          <br />
          <em>Excursão</em>
          <br />
          do jeito certo.
        </S.Title>
        <S.Subtitle>
          Chega de planilhas e grupos de WhatsApp bagunçados. O Excursei
          organiza passageiros, documentos e pagamentos em um único aplicativo
          simples e eficiente.
        </S.Subtitle>
        <S.CTAs>
          <S.BtnPrimary
            href="#download"
            className="btn-primary"
            onClick={(e) => handleClick(e, '#download')}
          >
            <svg
              width="15"
              height="15"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            Começar Grátis
          </S.BtnPrimary>
          <S.BtnSecondary
            href="#como-funciona"
            onClick={(e) => handleClick(e, '#como-funciona')}
          >
            Ver como funciona →
          </S.BtnSecondary>
        </S.CTAs>
        <S.SocialProof>
          <S.Avatars>
            <span>M</span>
            <span>R</span>
            <span>C</span>
            <span>+</span>
          </S.Avatars>
          <S.ProofText>
            <strong>+500 organizadores</strong> já confiam no Excursei
            <br />
            e economizam horas toda semana
          </S.ProofText>
        </S.SocialProof>
      </S.Content>

      <S.HeroVisual
        as={motion.div}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <S.PhoneScene>
          <S.PhoneGlow />
          <S.PhoneFrame>
            <img src="/assets/app-mockup.png" alt="Interface do App Excursei" />
          </S.PhoneFrame>
          <S.FloatNotif $position="a">
            <S.FloatNotifIcon>✅</S.FloatNotifIcon>
            <S.FloatNotifText>
              <strong>Pagamento confirmado</strong>
              <span>João Silva — R$ 280,00</span>
            </S.FloatNotifText>
          </S.FloatNotif>
          <S.FloatNotif $position="b">
            <S.FloatNotifIcon>🔔</S.FloatNotifIcon>
            <S.FloatNotifText>
              <strong>Lembrete enviado!</strong>
              <span>3 dias para a viagem</span>
            </S.FloatNotifText>
          </S.FloatNotif>
        </S.PhoneScene>
      </S.HeroVisual>
    </S.Container>
  );
};
